/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PortfolioCashAccountDetails
 */
export interface PortfolioCashAccountDetails {
    /**
     * 
     * @type {string}
     * @memberof PortfolioCashAccountDetails
     */
    cashAccountId?: string;
    /**
     * 
     * @type {string}
     * @memberof PortfolioCashAccountDetails
     */
    cashAccountNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof PortfolioCashAccountDetails
     */
    currency?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PortfolioCashAccountDetails
     */
    blocked?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PortfolioCashAccountDetails
     */
    relatedCustody?: string;
    /**
     * 
     * @type {string}
     * @memberof PortfolioCashAccountDetails
     */
    accountType?: string;
    /**
     * 
     * @type {string}
     * @memberof PortfolioCashAccountDetails
     */
    accountStatus?: string;
    /**
     * True when this cash account is the Preferred Client Cash Account (PCCA) of the portfolio
     * @type {boolean}
     * @memberof PortfolioCashAccountDetails
     */
    pcca?: boolean;
    /**
     * Unique identifier generated by the service when the cash account is created
     * @type {string}
     * @memberof PortfolioCashAccountDetails
     */
    correlationId?: string;
    /**
     * 
     * @type {Date}
     * @memberof PortfolioCashAccountDetails
     */
    createdAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof PortfolioCashAccountDetails
     */
    createdBy?: string;
    /**
     * 
     * @type {Date}
     * @memberof PortfolioCashAccountDetails
     */
    modifiedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof PortfolioCashAccountDetails
     */
    modifiedBy?: string;
}

/**
 * Check if a given object implements the PortfolioCashAccountDetails interface.
 */
export function instanceOfPortfolioCashAccountDetails(value: object): value is PortfolioCashAccountDetails {
    return true;
}

export function PortfolioCashAccountDetailsFromJSON(json: any): PortfolioCashAccountDetails {
    return PortfolioCashAccountDetailsFromJSONTyped(json, false);
}

export function PortfolioCashAccountDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortfolioCashAccountDetails {
    if (json == null) {
        return json;
    }
    return {
        
        'cashAccountId': json['cashAccountId'] == null ? undefined : json['cashAccountId'],
        'cashAccountNumber': json['cashAccountNumber'] == null ? undefined : json['cashAccountNumber'],
        'currency': json['currency'] == null ? undefined : json['currency'],
        'blocked': json['blocked'] == null ? undefined : json['blocked'],
        'relatedCustody': json['relatedCustody'] == null ? undefined : json['relatedCustody'],
        'accountType': json['accountType'] == null ? undefined : json['accountType'],
        'accountStatus': json['accountStatus'] == null ? undefined : json['accountStatus'],
        'pcca': json['pcca'] == null ? undefined : json['pcca'],
        'correlationId': json['correlationId'] == null ? undefined : json['correlationId'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'createdBy': json['createdBy'] == null ? undefined : json['createdBy'],
        'modifiedAt': json['modifiedAt'] == null ? undefined : (new Date(json['modifiedAt'])),
        'modifiedBy': json['modifiedBy'] == null ? undefined : json['modifiedBy'],
    };
}

export function PortfolioCashAccountDetailsToJSON(json: any): PortfolioCashAccountDetails {
    return PortfolioCashAccountDetailsToJSONTyped(json, false);
}

export function PortfolioCashAccountDetailsToJSONTyped(value?: PortfolioCashAccountDetails | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'cashAccountId': value['cashAccountId'],
        'cashAccountNumber': value['cashAccountNumber'],
        'currency': value['currency'],
        'blocked': value['blocked'],
        'relatedCustody': value['relatedCustody'],
        'accountType': value['accountType'],
        'accountStatus': value['accountStatus'],
        'pcca': value['pcca'],
        'correlationId': value['correlationId'],
        'createdAt': value['createdAt'] == null ? value['createdAt'] : value['createdAt'].toISOString(),
        'createdBy': value['createdBy'],
        'modifiedAt': value['modifiedAt'] == null ? value['modifiedAt'] : value['modifiedAt'].toISOString(),
        'modifiedBy': value['modifiedBy'],
    };
}

